<div class="tree invert">
	<ul orgChartNode [node]="data" [isRoot]="true"></ul>
</div>
